import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';

import SEO from "@components/seo";
import MainContent from "@components/content";
import MiniProduct from "@components/miniProduct";

import * as Types from '../../types';
import Search from "@components/search";

import { useScrollSave } from "@hooks/useScrollSave";

export default function Catalog() {
  const { id } = useParams();
  const [category, setCategory] = useState<Types.Category>();
  const [products, setProducts] = useState<Types.Product[]>();

  const [limit, _] = useState(51);
  const [start, setStart] = useState(0);
  const [loading, setLoading] = useState(false);

  const { restoredData, isRestored, updateScrollY } = useScrollSave(
    `catalog_scroll_${id}`,
    { products, start },
    products && products.length > 0
  );

  useEffect(() => {
    if (restoredData) {
      setProducts(restoredData.products);
      setStart(restoredData.start);
    }
  }, [restoredData]);

  useEffect(() => {
    if (isRestored.current) {
      isRestored.current = false;
    }

    setLoading(true);

    const productsReq = axios.get(
      `${import.meta.env.VITE_API_URL}/products/c/${id}?limit=${limit}&start=${start}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    const categoryReq = axios.get(
      `${import.meta.env.VITE_API_URL}/categories/${id}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    Promise.all([productsReq, categoryReq])
      .then(([productsRes, categoryRes]) => {
        if (start === 0) {
          setProducts(productsRes.data);
        } else {
          setProducts((prevProducts: any) => [...prevProducts, ...productsRes.data]);
        }

        setCategory(categoryRes.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [id, limit, start]);
  
  const handleScroll = useCallback((e: any) => {
    updateScrollY(e);
    const bottom = e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;
    if (bottom && !loading) {
      setLoading(true);
      setStart((prevStart) => prevStart + limit);
    }
  }, [loading, limit, updateScrollY]);

  useEffect(() => {
    const container = document.getElementById('scrollable-content');
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);


  return (
    <MainContent header={`n`}> 
      <SEO 
        title={`${category?.name}`}
        description={`${category?.miniDesc}`}
        ogImage={`${category?.coverImg}`}
        ogUrl={`${category?.linkCover}`}
      />

      <div className={css.header}>
        <h1>{category?.name}</h1>
        <Search />
      </div>

      <div className={css.productList}>
        {products?.map((product: Types.Product) => (
          <MiniProduct 
            id={product.id}
            product={product}
            title={product.name}
            price={product.price}
            image={product.images[0]}
            unit={product.unit}
            quantity={product.quantity}
          />
        ))}

        {loading && <div>загружаем...</div>}
      </div>
    </MainContent>
  )
}